module.exports = __webpack_public_path__ + "fonts/Source-Sans-Pro-Regular.899c8f78.woff2";